import { UserSummary, Address } from '../types';
import COUNTRY_CODES from '../types/countryCodes';

class User implements UserSummary {
  id: number;

  type: number;

  fullName: string;

  companyId: number;

  companyName: string;

  lang: string;

  rating: number;

  profilePictureUrl: string;

  companyAddress: Address;

  isCanSell: boolean;

  isTrdExemptBuyer: boolean;

  usersList: any;

  static transform(data: any) {
    return data;
  }

  constructor(data: any) {
    this.id = data?.id;
    this.type = data?.type;
    this.fullName = data?.fullName;
    this.companyId = data?.companyId;
    this.lang = data?.lang;
    this.rating = data?.rating;
    this.profilePictureUrl = data?.profilePictureUrl;
    this.companyAddress = data?.companyAddress;
    this.isCanSell = data?.isCanSell;
    this.isTrdExemptBuyer = data?.isTrdExemptBuyer;
  }

  static isCountryCanada(id) {
    return id === COUNTRY_CODES.CA;
  }

  static isCountryUS(id) {
    return id === COUNTRY_CODES.US;
  }
}

export default User;
